import { ManageCustomers } from "./manageCustomers";

export default ManageCustomers;
